import React, { createContext, useRef, useState } from "react";
import useOrders from "../../hooks/useOrders";
import { enqueueSnackbar, useSnackbar } from "notistack";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PaymentMethod from "../flight/PaymentMethod";
import Modal1 from "../DIsplay/Modal/Modal1";
import CancelTicket from "../../pages/Orders/CancelTicket";
import CancelOrder from "../../pages/Orders/cancelOrder";
import ApproveFreezeOrder from "../../pages/Orders/approveFreezeOrder";
import ManageFreezeOrderModal from "../modal/ManageFreezeOrderModal";
import IssueTicket from "../../pages/Orders/IssueTicket";
import Rebook from "../flight/book/Rebook";
import moment from "moment";
import refreshTicket from "../../controllers/booking/refreshTicket";
import issueTicket from "../../controllers/booking/issueTicket";
import { ManualTicketForm } from "../../pages/Orders/ApproveTicket";
import Button1 from "../form/Button1";
import issueTicketManually from "../../controllers/booking/issueTicketManually";
import approveTicket from "../../controllers/booking/Ticket/approveTicket";
import TextInput from "../form/TextInput";
import denyTicket from "../../controllers/booking/Ticket/denyTicket";
import requestTicketMoreInfo from "../../controllers/booking/Ticket/requestMoreInfo";
import voidTicketRequest from "../../controllers/booking/postTicketing/void/voidTicketRequest";
import approveVoidTicket from "../../controllers/booking/postTicketing/void/approveVoidTicket";
import approveRefundTicket from "../../controllers/booking/postTicketing/refund/approveRefundTicket";
import denyVoidRequest from "../../controllers/booking/postTicketing/void/denyVoidRequest";
import setRefundFee from "../../controllers/booking/postTicketing/refund/setRefundFee";
import approveChangeTicketRequest from "../../controllers/booking/postTicketing/change/approveChangeTicketRequest";
import setChangeFee from "../../controllers/booking/postTicketing/change/setChangeFee";
import { Modal3 } from "../DIsplay/Modal/Modal3";
import TicketManagementFlightOrderDetail from "../../pages/TicketManagement/Flight/TicketManagementFlightOrderDetail";
import AssignChange from "./Change/AssignChange";
import ChangeQuote from "./Change/ChangeQuote";
import ChangeDeclineModal from "./Change/ChangeDeclineModal";
import ChangeFareRulesModal from "../../pages/TicketManagement/Flight/Change/ChangeFareRulesModal";
import ChangeMessagesModal from "../../pages/TicketManagement/Flight/Change/ChangeMessagesModal";
import VoidMessagesModal from "../../pages/TicketManagement/Flight/Void/VoidMessagesModal";
import SupplierResponseModal from "./Void/SupplierResponseView";
import RefundMessagesModal from "../../pages/TicketManagement/Flight/Refund/RefundMessagesModal";
import ChangeBankTransferProofModal from "../../pages/TicketManagement/Flight/Change/ChangeBankTransferProofModal";
import AssignRefund from "./Refund/AssignRefund";
import AddRefundRemark from "./Refund/AddRefundRemark";
import RefundQuote from "./Refund/RefundQuote";
import ApproveRefundQuoteModal from "./Refund/ApproveRefundQuoteModal";
import RefundDeclineModal from "./Refund/RefundDeclineModal";
import AssignTicket from "./Ticket/AssignTicket";
import AssignVoid from "./Void/AssignVoid";
import AddVoidRemark from "./Void/AddVoidRemark";
import ManualChange from "./Change/ManualChange";
import ManualRefund from "./Refund/ManualRefund";
import ManualVoid from "./Void/ManualVoid";
import { CircularProgress } from "@mui/material";
import OrderStatus from "./OrderStatus";
import OrderMenu from "./menu/OrderMenu";
import PinForm from "../Settings/PinForm";
import checkRefundPrice from "../../controllers/booking/postTicketing/refund/checkRefundPrice";
import checkRefundStatus from "../../controllers/booking/postTicketing/refund/checkRefundStatus";
import refundTicketRequest from "../../controllers/booking/postTicketing/refund/refundTicketRequest";
import manualRefund from "../../controllers/booking/postTicketing/refund/manualRefund";
import manualVoid from "../../controllers/booking/postTicketing/void/manualVoid";
import holdFlightBooking from "../../controllers/booking/holdFlightBooking";
import FlightDoc from "../../pages/Orders/Flight/Booked/FlightDoc";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import getBooking from "../../controllers/booking/getBooking";
import SeatSelectionHandler from "../flight/Seat/SeatSelectionHandler";
import EmailExport from "../../pages/Orders/Flight/Booked/EmailExport";
import { shareFlightBookingPDF } from "../../controllers/Flight/shareFlightBookingPDF";
import useFlightBooking from "../../hooks/flight/useFlightBooking";
import CustomerStatus from "./CustomerStatus";
import AbilityStatus from "./AbilityStatus";
import ManualChangeQuote from "./Change/ManualChangeQuote";
import AddRemarkMessage from "./Change/AddRemarkMessage";
import ManualUpdate, {
  buildManualChangePayload,
} from "./Change/ManualUpdate";
import ChangeSupplierOutcomeForm, {
  CHANGE_SUPPLIER_OUTCOME,
} from "./Change/ChangeSupplierOutcomeForm";
import CustomerModalContainer from "./CustomerModalContainer";
import submitRefund from "../../controllers/booking/postTicketing/refund/submitRefund";
import submitChange from "../../controllers/booking/postTicketing/change/submitChange";
import reissue from "../../controllers/booking/postTicketing/change/reissue";
import manualChange from "../../controllers/booking/postTicketing/change/manualChange";
import adminPayForChangeRequest from "../../controllers/booking/postTicketing/change/adminPayForChangeRequest";
import Toggle from "./Toggle";
import EditTicket from "./Change/EditTicket";
import ActiveStatus from "./ActiveStatus";
import FlightAdminPayModal from "../modal/customerModal/FlightAdminPayModal";
import EditPayableForFlightModal from "../modal/EditPayableForFlightModal";
import StaffAsyncActionModal from "./StaffAsyncActionModal";
import StaffApiErrorModal, {
  getStaffApiErrorCopy,
} from "./StaffApiErrorModal";
import RefundReviewModal from "../../pages/TicketManagement/Flight/Refund/RefundReviewModal";
import VoidReviewModal from "../../pages/TicketManagement/Flight/Void/VoidReviewModal";
import ChangeReviewModal from "../../pages/TicketManagement/Flight/Change/ChangeReviewModal";
import ChangeSelectedOfferModal from "../../pages/TicketManagement/Flight/Change/ChangeSelectedOfferModal";
import OpenTicketReviewModal from "../../pages/TicketManagement/Flight/OpenTicket/OpenTicketReviewModal";
import { canEnterRefundQuote, isRefundNotApprovedError, getRefundSupplierCheckCopy, getRefundConfirmCopy, getRefundConfirmWarningCopy, getRefundReimburseCopy, getRefundReimburseWarningCopy, getRefundSubmitActionLabel, getRefundPriceFailedCopy, isRefundQuotedStatus, isRefundQuoteExpiredForDisplay, getRefundRetryAutoWarningCopy, getRefundRetryAutoCopy, getRefundRetryAutoActionLabel, getRefundRetryAutoConfirmLabel, getRefundRetryAutoLoadingTitle } from "../../data/flight/order/getRefundAdminGuidance";
import { getVoidSubmitWarningCopy, getVoidSubmitCopy, getVoidManualWarningCopy, getVoidManualCopy, getVoidManualActionLabel, getVoidManualLoadingTitle, getVoidDeclineActionLabel, getVoidSubmitActionLabel, getVoidRetryAutoConfirmLabel, getVoidRetryAutoLoadingTitle, getVoidAirlineDeclinedActionLabel, getVoidAirlineDeclinedWarningCopy, getVoidAirlineDeclinedCopy, VOID_AIRLINE_DECLINED_REASON, isVoidCloseRequestStage, isVoidWalletCreditStage } from "../../data/flight/order/getVoidAdminGuidance";
import { getChangeSubmitWarningCopy, getChangeSubmitCopy, getChangeManualWarningCopy, getChangeReissueWarningCopy, getChangeReissueCopy, getChangeRetryAutoWarningCopy, getChangeRetryAutoCopy, getChangeRetryAutoActionLabel, getChangeRetryAutoConfirmLabel, getChangeRetryAutoLoadingTitle, getOpenTicketProceedWarningCopy, getOpenTicketProceedCopy, getOpenTicketOpenedWarningCopy, getOpenTicketOpenedCopy, OPEN_TICKET_OUTCOME } from "../../data/flight/order/getChangeAdminGuidance";
import proceedOpenTicketWithSupplier from "../../controllers/booking/postTicketing/change/proceedOpenTicketWithSupplier";
import recordOpenTicketOutcome from "../../controllers/booking/postTicketing/change/recordOpenTicketOutcome";

export const ActionContext = createContext();

function OrderList({ perPage = 10, reload }) {
  const {
    userData: { user },
  } = useSelector((state) => state.user);

  const { getOrders } = useOrders();
  const [orders, ogData] = getOrders() || [[], []];

  const [openPayment, setOpenPayment] = useState(false);
  const [openCancelTicket, setOpenCancelTicket] = useState(false);
  const [openCancelOrder, setOpenCancelOrder] = useState(false);
  const [openApproveFreeze, setOpenApproveFreeze] = useState(false);
  const [openManageFreeze, setOpenManageFreeze] = useState(false);
  const [openIssueTicket, setOpenIssueTicket] = useState(false);
  const [openVoidTicket, setOpenVoidTicket] = useState(false);
  const [openRebook, setOpenRebook] = useState(false);
  const [openManualIssue, setOpenManualIssue] = useState(false);
  const [openDeny, setOpenDeny] = useState(false);
  const [openRequestInfo, setOpenRequestInfo] = useState(false);
  const [openDenyVoid, setOpenDenyVoid] = useState(false);
  const [openRefundTicket, setOpenRefundTicket] = useState(false);
  const [openEditRefund, setOpenEditRefund] = useState(false);
  const [openDenyRefund, setOpenDenyRefund] = useState(false);
  const [openApproveRefund, setOpenApproveRefund] = useState(false);
  const [openReviewRefund, setOpenReviewRefund] = useState(false);
  const [openReviewVoid, setOpenReviewVoid] = useState(false);
  const [openReviewChange, setOpenReviewChange] = useState(false);
  const [openReviewOpenTicket, setOpenReviewOpenTicket] = useState(false);
  const [openProcessOpenTicket, setOpenProcessOpenTicket] = useState(false);
  const [openRecordOpenTicket, setOpenRecordOpenTicket] = useState(false);
  const [openSubmitRefund, setOpenSubmitRefund] = useState(false);
  const [openEditChange, setOpenEditChange] = useState(false);
  const [openDenyChange, setOpenDenyChange] = useState(false);
  const [openApproveTicket, setOpenApproveTicket] = useState(false);
  const [openViewDetail, setOpenViewDetail] = useState(false);
  const [openTicketMoreInfo, setOpenTicketMoreInfo] = useState(false);
  const [openAssignTicket, setOpenAssignTicket] = useState(false);
  const [openAssignVoid, setOpenAssignVoid] = useState(false);
  const [openApproveChange, setOpenApproveChange] = useState(false);
  const [openSubmitChange, setOpenSubmitChange] = useState(false);
  const [openAdminChangePay, setOpenAdminChangePay] = useState(false);
  const [openAssignChangeTask, setOpenAssignChangeTask] = useState(false);
  const [openAssignRefund, setOpenAssignRefund] = useState(false);
  const [openUpdateChangeRequest, setOpenUpdateChangeRequest] = useState(false);
  const [openVoidRemark, setOpenVoidRemark] = useState(false);
  const [openRefundRemark, setOpenRefundRemark] = useState(false);
  const [openChangeQuote, setOpenChangeQuote] = useState(false);
  const [openChangeFareRules, setOpenChangeFareRules] = useState(false);
  const [openChangeSelectedOffer, setOpenChangeSelectedOffer] = useState(false);
  const [openChangeMessages, setOpenChangeMessages] = useState(false);
  const [openVoidMessages, setOpenVoidMessages] = useState(false);
  const [openVoidSupplierResponse, setOpenVoidSupplierResponse] =
    useState(false);
  const [openRefundMessages, setOpenRefundMessages] = useState(false);
  const [openOrderMessages, setOpenOrderMessages] = useState(false);
  const [openChangeBankTransferProof, setOpenChangeBankTransferProof] =
    useState(false);
  const [openEditTicket, setOpenEditTicket] = useState(false);
  const [openManualChangeQuote, setOpenManualChangeQuote] = useState(false);
  const [openRefundQuote, setOpenRefundQuote] = useState(false);
  const [openApproveRefundQuote, setOpenApproveRefundQuote] = useState(false);
  const [openManualUpdate, setOpenManualUpdate] = useState(false);
  const [openChangeSupplierOutcome, setOpenChangeSupplierOutcome] =
    useState(false);
  const [openManualVoid, setOpenManualVoid] = useState(false);
  const [openManualRefund, setOpenManualRefund] = useState(false);
  const [openPDFExport, setOpenPDFExport] = useState(false);
  const [openEmailExport, setOpenEmailExport] = useState(false);
  const [openAddSeat, setOpenAddSeat] = useState(false);
  const [openEditPayable, setOpenEditPayable] = useState(false);
  const [airlinePriceModal, setAirlinePriceModal] = useState({
    open: false,
    order: null,
    phase: "loading",
    title: "",
    text: "",
    steps: [],
  });
  const [supplierStatusModal, setSupplierStatusModal] = useState({
    open: false,
    order: null,
    phase: "loading",
    kind: "",
    title: "",
    text: "",
  });
  const [voidActionModal, setVoidActionModal] = useState({
    open: false,
    order: null,
    phase: "loading",
    kind: "",
    title: "",
    text: "",
  });
  const [changeActionModal, setChangeActionModal] = useState({
    open: false,
    order: null,
    phase: "loading",
    kind: "",
    title: "",
    text: "",
  });
  const [refundRetryModal, setRefundRetryModal] = useState({
    open: false,
    order: null,
    phase: "loading",
    kind: "",
    title: "",
    text: "",
  });
  const [staffApiError, setStaffApiError] = useState(null);

  function showStaffApiError(res, title) {
    setStaffApiError(getStaffApiErrorCopy(res, title));
  }

  const { handlePDFExport: pdfExport } = useFlightBooking();

  const { ticketsPage: page } = useSelector((state) => state.order);
  const offset = ((page || 1) - 1) * perPage;

  const dispatch = useDispatch();
  const location = useLocation();
  const searchParam = new URLSearchParams(location.search);

  async function handleRefresh(id) {
    const res = await refreshTicket(id);
    if (res.return) {
      // enqueueSnackbar('Ticket has been issued.',{variant: 'success'})
      reload && reload();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }
  async function handleRefreshRefundFee(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setAirlinePriceModal({
      open: true,
      order,
      phase: "loading",
      title: "",
      text: "",
      steps: [],
    });
    const res = await checkRefundPrice(order._id);
    if (res.return && res?.data?.priceReceived) {
      setAirlinePriceModal({
        open: true,
        order,
        phase: "success",
        title: "We got a price",
        text: canEnterRefundQuote(order)
          ? "The supplier sent a refund price. Open the quote, check the numbers, and send it to the agent. Do not pay the agent yet."
          : "Accept this request next, then enter the quote.",
        steps: [],
      });
      return;
    }
    const failed = getRefundPriceFailedCopy(res, {
      canQuote: canEnterRefundQuote(order),
    });
    setAirlinePriceModal({
      open: true,
      order,
      phase: "error",
      title: failed.title,
      text: failed.text,
      steps: failed.steps,
    });
  }
  async function handleRefreshRefund(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setSupplierStatusModal({
      open: true,
      order,
      phase: "loading",
      kind: "",
      title: "",
      text: "",
    });
    const res = await checkRefundStatus(order._id);
    const copy = getRefundSupplierCheckCopy(res, order.status);
    setSupplierStatusModal({
      open: true,
      order,
      ...copy,
    });
  }

  async function handleConfirmRefundNow(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setSupplierStatusModal({
      open: true,
      order,
      phase: "loading",
      kind: "confirming",
      title: "",
      text: "",
    });
    const res = await refundTicketRequest(order._id);
    const copy = getRefundConfirmCopy(res);
    setSupplierStatusModal({
      open: true,
      order,
      ...copy,
    });
  }

  function promptConfirmRefundNow(order) {
    setSupplierStatusModal((prev) => ({
      open: true,
      order: order || prev.order,
      previous: {
        phase: prev.phase,
        kind: prev.kind,
        title: prev.title,
        text: prev.text,
        steps: prev.steps,
      },
      ...getRefundConfirmWarningCopy(),
    }));
  }

  function promptRetryAutoRefund(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setRefundRetryModal({
      open: true,
      order,
      ...getRefundRetryAutoWarningCopy(),
    });
  }

  async function runRetryAutoRefund(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setRefundRetryModal({
      open: true,
      order,
      phase: "loading",
      kind: "retry_autoing",
      title: "",
      text: "",
    });
    const res = await refundTicketRequest(order._id);
    setRefundRetryModal({
      open: true,
      order,
      ...getRefundRetryAutoCopy(res),
    });
  }

  function getRefundRetryActions() {
    const kind = refundRetryModal.kind;
    const order = refundRetryModal.order;
    const close = () =>
      setRefundRetryModal((prev) => ({ ...prev, open: false }));
    const goBack = { label: "Go back", onClick: close };
    const seeLatest = {
      label: "See the latest status",
      primary: true,
      onClick: () => {
        close();
        reload && reload();
      },
    };
    switch (kind) {
      case "retry_auto_warn":
        return [
          {
            label: getRefundRetryAutoConfirmLabel(),
            primary: true,
            onClick: () => runRetryAutoRefund(order),
          },
          goBack,
        ];
      case "retry_autoed":
        return [seeLatest];
      case "retry_auto_failed":
        return [
          {
            label: "Try again",
            primary: true,
            onClick: () => runRetryAutoRefund(order),
          },
        ];
      default:
        return [goBack];
    }
  }

  function promptReimburseNow(order) {
    setSupplierStatusModal((prev) => ({
      open: true,
      order: order || prev.order,
      previous: {
        phase: prev.phase,
        kind: prev.kind,
        title: prev.title,
        text: prev.text,
        steps: prev.steps,
      },
      ...getRefundReimburseWarningCopy(order || prev.order),
    }));
  }

  async function handleReimburseNow(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setSupplierStatusModal({
      open: true,
      order,
      phase: "loading",
      kind: "reimbursing",
      title: "",
      text: "",
    });
    const res = await manualRefund(order._id);
    const copy = getRefundReimburseCopy(res);
    setSupplierStatusModal({
      open: true,
      order,
      ...copy,
    });
  }

  function goBackFromConfirmWarn() {
    setSupplierStatusModal((prev) => {
      if (
        prev.previous?.kind &&
        !["confirm_warn", "reimburse_warn"].includes(prev.previous.kind)
      ) {
        return {
          ...prev,
          ...prev.previous,
          previous: null,
        };
      }
      return { ...prev, open: false };
    });
  }

  function getSupplierStatusActions() {
    const kind = supplierStatusModal.kind;
    const order = supplierStatusModal.order;
    const close = () =>
      setSupplierStatusModal((prev) => ({ ...prev, open: false }));
    const tryAgain = {
      label: "Try again",
      onClick: () => handleRefreshRefund(order),
    };
    const assign = {
      label: "Assign",
      onClick: () => {
        setOpenAssignRefund(order);
        close();
      },
    };
    const seeLatest = {
      label: "See latest",
      primary: true,
      onClick: () => {
        close();
      reload && reload();
      },
    };
    const confirmNow = {
      label: "Confirm refund",
      onClick: () => promptConfirmRefundNow(order),
    };
    const reimburseNow = {
      label: "Credit wallet",
      onClick: () => promptReimburseNow(order),
    };
    const yesConfirm = {
      label: "Yes, continue",
      danger: true,
      onClick: () => handleConfirmRefundNow(order),
    };
    const yesReimburse = {
      label: "Yes, the ticket is refunded",
      danger: true,
      onClick: () => handleReimburseNow(order),
    };
    const goBack = {
      label: "Go back",
      onClick: () => goBackFromConfirmWarn(),
    };

    switch (kind) {
      case "succeeded":
        return [{ ...reimburseNow, primary: true }, seeLatest];
      case "completed":
      case "updated":
      case "confirmed":
      case "reimbursed":
        return [seeLatest];
      case "supplier_failed":
        return [reimburseNow, assign, tryAgain];
      case "confirm_warn":
        return [yesConfirm, goBack];
      case "reimburse_warn":
        return [yesReimburse, goBack];
      case "confirm_failed":
      case "reimburse_failed":
        return [{ ...reimburseNow, primary: true }, tryAgain, confirmNow];
      case "not_found":
      case "network":
      case "generic":
      case "still_waiting":
        return [
          { ...tryAgain, primary: true },
          reimburseNow,
          confirmNow,
          assign,
        ];
      default:
        return [tryAgain];
    }
  }

  function promptSubmitVoid(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setVoidActionModal({
      open: true,
      order,
      ...getVoidSubmitWarningCopy(),
    });
  }

  function promptRecordManualVoid(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setVoidActionModal({
      open: true,
      order,
      ...getVoidManualWarningCopy(order),
    });
  }

  function promptAirlineDeclinedVoid(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setVoidActionModal({
      open: true,
      order,
      ...getVoidAirlineDeclinedWarningCopy(),
    });
  }

  async function runAirlineDeclinedVoid(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setVoidActionModal({
      open: true,
      order,
      phase: "loading",
      kind: "airline_declining",
      title: "",
      text: "",
    });
    const res = await denyVoidRequest(order._id, {
      rejectReason: VOID_AIRLINE_DECLINED_REASON,
    });
    setVoidActionModal({
      open: true,
      order,
      ...getVoidAirlineDeclinedCopy(res),
    });
  }

  async function runSubmitVoid(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setVoidActionModal({
      open: true,
      order,
      phase: "loading",
      kind: "submitting",
      title: "",
      text: "",
    });
    const res = await voidTicketRequest(order._id);
    setVoidActionModal({
      open: true,
      order,
      ...getVoidSubmitCopy(res),
    });
  }

  async function runRecordManualVoid(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setVoidActionModal({
      open: true,
      order,
      phase: "loading",
      kind: "manualing",
      title: "",
      text: "",
    });
    const res = await manualVoid(order._id);
    setVoidActionModal({
      open: true,
      order,
      ...getVoidManualCopy(res, order),
    });
  }

  function getVoidActionActions() {
    const kind = voidActionModal.kind;
    const order = voidActionModal.order;
    const close = () =>
      setVoidActionModal((prev) => ({ ...prev, open: false }));
    const trySubmit = {
      label: "Try again",
      onClick: () => runSubmitVoid(order),
    };
    const tryManual = {
      label: "Try again",
      onClick: () => runRecordManualVoid(order),
    };
    const assign = {
      label: "Give to a teammate",
      onClick: () => {
        setOpenAssignVoid(order);
        close();
      },
    };
    const seeLatest = {
      label: "See the latest status",
      primary: true,
      onClick: () => {
        close();
        reload && reload();
      },
    };
    const yesSubmit = {
      label: getVoidRetryAutoConfirmLabel(),
      primary: true,
      onClick: () => runSubmitVoid(order),
    };
    const yesManual = {
      label: isVoidWalletCreditStage(order)
        ? "Yes, credit the agent wallet"
        : "Yes, complete and pay the agent",
      danger: true,
      onClick: () => runRecordManualVoid(order),
    };
    const yesAirlineDeclined = {
      label: "Yes, airline declined — close this void",
      danger: true,
      onClick: () => runAirlineDeclinedVoid(order),
    };
    const goBack = {
      label: "Go back",
      onClick: close,
    };
    const switchToManual = {
      label: getVoidManualActionLabel(order),
      onClick: () => promptRecordManualVoid(order),
    };
    const switchToSubmit = {
      label: getVoidSubmitActionLabel(),
      onClick: () => promptSubmitVoid(order),
    };
    const tryAirlineDeclined = {
      label: "Try again",
      onClick: () => runAirlineDeclinedVoid(order),
    };

    switch (kind) {
      case "submit_warn":
        return [yesSubmit, goBack];
      case "manual_warn":
        return [yesManual, goBack];
      case "airline_decline_warn":
        return [yesAirlineDeclined, goBack];
      case "submitted":
      case "manualed":
      case "airline_declined":
        return [seeLatest];
      case "submit_failed":
        return [{ ...trySubmit, primary: true }];
      case "manual_failed":
        return [{ ...tryManual, primary: true }, switchToSubmit, assign];
      case "airline_decline_failed":
        return [{ ...tryAirlineDeclined, primary: true }, assign];
      default:
        return [goBack];
    }
  }

  function promptSubmitChange(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setChangeActionModal({
      open: true,
      order,
      ...getChangeSubmitWarningCopy(order),
    });
  }

  function promptRetryAutoChange(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setChangeActionModal({
      open: true,
      order,
      ...getChangeRetryAutoWarningCopy(order),
    });
  }

  async function runRetryAutoChange(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setChangeActionModal({
      open: true,
      order,
      phase: "loading",
      kind: "retry_autoing",
      title: "",
      text: "",
    });
    const res = await reissue({ changeOrderId: order._id });
    setChangeActionModal({
      open: true,
      order,
      ...getChangeRetryAutoCopy(res),
    });
  }

  function promptRecordManualChange(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setChangeActionModal({
      open: true,
      order,
      ...getChangeManualWarningCopy(order),
    });
  }

  async function runSubmitChange(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setChangeActionModal({
      open: true,
      order,
      phase: "loading",
      kind: "submitting",
      title: "",
      text: "",
    });
    const res = await submitChange(order._id);
    setChangeActionModal({
      open: true,
      order,
      ...getChangeSubmitCopy(res),
    });
  }

  function promptConfirmReissue(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setChangeActionModal({
      open: true,
      order,
      ...getChangeReissueWarningCopy(order),
    });
  }

  async function runConfirmReissue(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setChangeActionModal({
      open: true,
      order,
      phase: "loading",
      kind: "reissuing",
      title: "",
      text: "",
    });
    const res = await manualChange(buildManualChangePayload(order));
    setChangeActionModal({
      open: true,
      order,
      ...getChangeReissueCopy(res),
    });
  }

  function promptProceedOpenTicket(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setChangeActionModal({
      open: true,
      order,
      ...getOpenTicketProceedWarningCopy(order),
    });
  }

  async function runProceedOpenTicket(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setChangeActionModal({
      open: true,
      order,
      phase: "loading",
      kind: "open_proceeding",
      title: "",
      text: "",
    });
    const res = await proceedOpenTicketWithSupplier(order._id);
    setChangeActionModal({
      open: true,
      order,
      ...getOpenTicketProceedCopy(res),
    });
  }

  function promptRecordOpenedOpenTicket(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setChangeActionModal({
      open: true,
      order,
      ...getOpenTicketOpenedWarningCopy(order),
    });
  }

  async function runRecordOpenedOpenTicket(orderOrId) {
    const order =
      typeof orderOrId === "object" && orderOrId?._id
        ? orderOrId
        : { _id: orderOrId };
    setChangeActionModal({
      open: true,
      order,
      phase: "loading",
      kind: "open_opening",
      title: "",
      text: "",
    });
    const res = await recordOpenTicketOutcome(order._id, {
      outcome: OPEN_TICKET_OUTCOME.SUCCESS,
    });
    setChangeActionModal({
      open: true,
      order,
      ...getOpenTicketOpenedCopy(res),
    });
  }

  function getChangeActionActions() {
    const kind = changeActionModal.kind;
    const order = changeActionModal.order;
    const close = () =>
      setChangeActionModal((prev) => ({ ...prev, open: false }));
    const trySubmit = {
      label: "Try again",
      onClick: () => runSubmitChange(order),
    };
    const tryRetryAuto = {
      label: "Try again",
      onClick: () => runRetryAutoChange(order),
    };
    const assign = {
      label: "Give to a teammate",
      onClick: () => {
        setOpenAssignChangeTask(order);
        close();
      },
    };
    const seeLatest = {
      label: "See the latest status",
      primary: true,
      onClick: () => {
        close();
        reload && reload();
      },
    };
    const yesRetryAuto = {
      label: getChangeRetryAutoConfirmLabel(),
      primary: true,
      onClick: () => runRetryAutoChange(order),
    };
    const yesSubmit = {
      label: "Yes, sent to airline",
      primary: true,
      onClick: () => runSubmitChange(order),
    };
    const yesManual = {
      label: "Yes, I already completed it",
      onClick: () => {
        setOpenManualUpdate(order);
        close();
      },
    };
    const yesReissue = {
      label: "Yes, the airline reissued it",
      primary: true,
      onClick: () => runConfirmReissue(order),
    };
    const tryReissue = {
      label: "Try again",
      onClick: () => runConfirmReissue(order),
    };
    const yesProceedOpen = {
      label: "Yes, proceed with the airline",
      primary: true,
      onClick: () => runProceedOpenTicket(order),
    };
    const tryProceedOpen = {
      label: "Try again",
      onClick: () => runProceedOpenTicket(order),
    };
    const yesOpenedOpen = {
      label: "Yes, the airline opened it",
      primary: true,
      onClick: () => runRecordOpenedOpenTicket(order),
    };
    const tryOpenedOpen = {
      label: "Try again",
      onClick: () => runRecordOpenedOpenTicket(order),
    };
    const goBack = {
      label: "Go back",
      onClick: close,
    };
    const switchToManual = {
      label: "Record a manual change",
      onClick: () => promptRecordManualChange(order),
    };

    switch (kind) {
      case "retry_auto_warn":
        return [yesRetryAuto, goBack];
      case "submit_warn":
        return [yesSubmit, goBack];
      case "manual_warn":
        return [yesManual, goBack];
      case "reissue_warn":
        return [yesReissue, goBack];
      case "open_proceed_warn":
        return [yesProceedOpen, goBack];
      case "open_opened_warn":
        return [yesOpenedOpen, goBack];
      case "submitted":
      case "reissued":
      case "retry_autoed":
      case "open_proceeded":
      case "open_opened":
        return [seeLatest];
      case "retry_auto_failed":
        return [{ ...tryRetryAuto, primary: true }];
      case "submit_failed":
        return [{ ...trySubmit, primary: true }, switchToManual, assign];
      case "reissue_failed":
        return [{ ...tryReissue, primary: true }, assign];
      case "open_proceed_failed":
        return [{ ...tryProceedOpen, primary: true }, assign];
      case "open_opened_failed":
        return [{ ...tryOpenedOpen, primary: true }, assign];
      default:
        return [goBack];
    }
  }

  const [openIssue, setOpenIssue] = useState(false);

  async function handleApproveVoid(id) {
    const res = await approveVoidTicket(id);
    if (res.return) {
      enqueueSnackbar("Request has been approved.", { variant: "success" });
      reload && reload();
    } else showStaffApiError(res);
  }

  async function handlePDFExport(id) {
    setOpenPDFExport("loading");
    await pdfExport({ id, callback: (res) => setOpenPDFExport(res?.data) });
  }

  async function handleHoldFlightBooking(id) {
    const res = await holdFlightBooking(id);
    if (res.return) {
      enqueueSnackbar(res.msg, { variant: "success" });
      reload && reload();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  return (
    <div>
      <ActionContext.Provider
        value={{
          reload,
          openPayment,
          setOpenPayment,
          openCancelTicket,
          setOpenCancelTicket,
          openCancelOrder,
          setOpenCancelOrder,
          openApproveFreeze,
          setOpenApproveFreeze,
          openManageFreeze,
          setOpenManageFreeze,
          openIssueTicket,
          setOpenIssueTicket,
          openVoidTicket,
          setOpenVoidTicket,
          openRebook,
          setOpenRebook,
          refreshTicket: handleRefresh,
          issue: setOpenIssue,
          manualIssue: setOpenManualIssue,
          approve: setOpenApproveTicket,
          deny: setOpenDeny,
          requestInfo: setOpenRequestInfo,
          approveVoid: handleApproveVoid,
          denyVoid: setOpenDenyVoid,
          approveRefund: setOpenApproveRefund,
          reviewRefund: setOpenReviewRefund,
          reviewVoid: setOpenReviewVoid,
          reviewChange: setOpenReviewChange,
          reviewOpenTicket: setOpenReviewOpenTicket,
          processOpenTicket: setOpenProcessOpenTicket,
          recordOpenTicket: setOpenRecordOpenTicket,
          submitVoid: promptSubmitVoid,
          recordManualVoid: promptRecordManualVoid,
          promptAirlineDeclinedVoid,
          addVoidRemark: setOpenVoidRemark,
          addRefundRemark: setOpenRefundRemark,
          promptSubmitChange,
          promptRetryAutoChange,
          promptRetryAutoRefund,
          recordManualChange: promptRecordManualChange,
          promptConfirmReissue,
          refreshRefund: handleRefreshRefund,
          refreshRefundFee: handleRefreshRefundFee,
          denyRefund: setOpenDenyRefund,
          setOpenEditRefund,
          refundTicket: setOpenAssignRefund,
          approveChange: setOpenApproveChange,
          denyChange: setOpenDenyChange,
          setOpenEditChange,
          openTicketMoreInfo,
          setOpenTicketMoreInfo,
          openViewDetail,
          setOpenViewDetail,
          openApproveTicket,
          setOpenApproveTicket,
          openSubmitChange,
          setOpenSubmitChange,
          setOpenAdminChangePay,
          assignChangeTask: setOpenAssignChangeTask,
          assignTicket: setOpenAssignTicket,
          assignVoid: setOpenAssignVoid,
          setOpenUpdateChangeRequest,
          setOpenChangeQuote,
          setOpenChangeFareRules,
          setOpenChangeSelectedOffer,
          setOpenChangeMessages,
          checkChangeMessages: setOpenChangeMessages,
          setOpenVoidMessages,
          checkVoidMessages: setOpenVoidMessages,
          viewVoidSupplierResponse: setOpenVoidSupplierResponse,
          viewChangeSupplierResponse: setOpenVoidSupplierResponse,
          viewRefundSupplierResponse: setOpenVoidSupplierResponse,
          setOpenRefundMessages,
          checkRefundMessages: setOpenRefundMessages,
          setOpenOrderMessages,
          setOpenChangeBankTransferProof,
          checkBankTransferProof: setOpenChangeBankTransferProof,
          setOpenEditTicket,
          setOpenManualChangeQuote,
          setOpenSubmitRefund,
          setOpenRefundQuote,
          approveRefundQuote: setOpenApproveRefundQuote,
          setOpenManualUpdate,
          recordChangeSupplierOutcome: setOpenChangeSupplierOutcome,
          setOpenManualRefund,
          setOpenManualVoid,
          holdFlightBooking: handleHoldFlightBooking,
          setOpenPDFExport: handlePDFExport,
          setOpenEmailExport,
          addSeat: setOpenAddSeat,
          addBag: setOpenAddSeat,
          setOpenEditPayable,
        }}
      >
        <div className="w-full flex flex-col mt-4 bg-[#F0F6FC] gap-3 p-1">
          {/* {orders?.slice(offset,offset+perPage).map((order, index) => ( */}
          {orders?.slice(0, perPage).map((order, index) => (
            <Order
              key={index}
              order={order}
              og={ogData?.slice(0, perPage)?.at(index)}
              reload={reload}
            />
          ))}
        </div>
      </ActionContext.Provider>

      <ActionHandles
        {...{ reload }}
        {...{ openPayment, setOpenPayment }}
        {...{ openCancelOrder, setOpenCancelOrder }}
        {...{ openApproveFreeze, setOpenApproveFreeze }}
        {...{ openManageFreeze, setOpenManageFreeze }}
        {...{ openCancelTicket, setOpenCancelTicket }}
        {...{ openIssueTicket, setOpenIssueTicket }}
        {...{ openVoidTicket, setOpenVoidTicket }}
        {...{ openRebook, setOpenRebook }}
        {...{ openManualIssue, setOpenManualIssue }}
        {...{ openDeny, setOpenDeny }}
        {...{ openDenyVoid, setOpenDenyVoid }}
        {...{ openApproveRefund, setOpenApproveRefund }}
        {...{ openDenyRefund, setOpenDenyRefund }}
        {...{ openRequestInfo, setOpenRequestInfo }}
        {...{ openEditRefund, setOpenEditRefund }}
        {...{ openRefundTicket, setOpenRefundTicket }}
        {...{ openDenyChange, setOpenDenyChange }}
        {...{ openEditChange, setOpenEditChange }}
        {...{ openTicketMoreInfo, setOpenTicketMoreInfo }}
        {...{ openViewDetail, setOpenViewDetail }}
        {...{ openApproveTicket, setOpenApproveTicket }}
        {...{ openAssignTicket, setOpenAssignTicket }}
        {...{ openAssignVoid, setOpenAssignVoid }}
        {...{ openApproveChange, setOpenApproveChange }}
        {...{ openAssignChangeTask, setOpenAssignChangeTask }}
        {...{ openSubmitChange, setOpenSubmitChange }}
        {...{ openAdminChangePay, setOpenAdminChangePay }}
        {...{ openUpdateChangeRequest, setOpenUpdateChangeRequest }}
        {...{ openVoidRemark, setOpenVoidRemark }}
        {...{ openRefundRemark, setOpenRefundRemark }}
        {...{ openChangeQuote, setOpenChangeQuote }}
        {...{ openChangeFareRules, setOpenChangeFareRules }}
        {...{ openChangeSelectedOffer, setOpenChangeSelectedOffer }}
        {...{
          openChangeMessages,
          setOpenChangeMessages,
          openVoidMessages,
          setOpenVoidMessages,
          openVoidSupplierResponse,
          setOpenVoidSupplierResponse,
          openRefundMessages,
          setOpenRefundMessages,
        }}
        {...{ openOrderMessages, setOpenOrderMessages }}
        {...{ openChangeBankTransferProof, setOpenChangeBankTransferProof }}
        {...{ openEditTicket, setOpenEditTicket }}
        {...{ openManualChangeQuote, setOpenManualChangeQuote }}
        {...{ openSubmitRefund, setOpenSubmitRefund }}
        {...{
          openRefundQuote,
          setOpenRefundQuote,
          openApproveRefundQuote,
          setOpenApproveRefundQuote,
        }}
        {...{ openAssignRefund, setOpenAssignRefund }}
        {...{ openManualUpdate, setOpenManualUpdate }}
        {...{ openChangeSupplierOutcome, setOpenChangeSupplierOutcome }}
        {...{ openManualRefund, setOpenManualRefund }}
        {...{ openManualVoid, setOpenManualVoid }}
        {...{ openIssue, setOpenIssue }}
        {...{ openPDFExport, setOpenPDFExport }}
        {...{ openEmailExport, setOpenEmailExport }}
        {...{ openAddSeat, setOpenAddSeat }}
        {...{ openEditPayable, setOpenEditPayable }}
        {...{ showStaffApiError }}
      />
      <StaffAsyncActionModal
        open={airlinePriceModal.open}
        setOpen={(next) =>
          setAirlinePriceModal((prev) => ({ ...prev, open: Boolean(next) }))
        }
        title="Get supplier price"
        phase={airlinePriceModal.phase}
        loadingTitle="Asking the supplier for a price"
        loadingText="This can take a few seconds. Stay on this screen. Do not click again."
        resultTitle={airlinePriceModal.title}
        resultText={airlinePriceModal.text}
        resultSteps={airlinePriceModal.steps}
        actions={
          airlinePriceModal.phase === "success"
            ? canEnterRefundQuote(airlinePriceModal.order)
              ? [
                  {
                    label: "See the quote",
                    primary: true,
                    onClick: () => {
                      setAirlinePriceModal({
                        open: false,
                        order: null,
                        phase: "loading",
                        title: "",
                        text: "",
                        steps: [],
                      });
                      reload && reload();
                    },
                  },
                ]
              : [
                  {
                    label: "Accept request",
                    primary: true,
                    onClick: () => {
                      setOpenApproveRefund(airlinePriceModal.order?._id);
                      setAirlinePriceModal((prev) => ({
                        ...prev,
                        open: false,
                      }));
                    },
                  },
                ]
            : airlinePriceModal.phase === "error"
              ? canEnterRefundQuote(airlinePriceModal.order)
                ? [
                    {
                      label: "Enter quote from airline",
                      primary: true,
                      onClick: () => {
                        setOpenRefundQuote(airlinePriceModal.order);
                        setAirlinePriceModal((prev) => ({
                          ...prev,
                          open: false,
                        }));
                      },
                    },
                    {
                      label: "Try again",
                      onClick: () =>
                        handleRefreshRefundFee(airlinePriceModal.order),
                    },
                    {
                      label: "Assign",
                      onClick: () => {
                        setOpenAssignRefund(airlinePriceModal.order);
                        setAirlinePriceModal((prev) => ({
                          ...prev,
                          open: false,
                        }));
                      },
                    },
                  ]
                : [
                    {
                      label: "Review this request",
                      primary: true,
                      onClick: () => {
                        setOpenReviewRefund(airlinePriceModal.order);
                        setAirlinePriceModal((prev) => ({
                          ...prev,
                          open: false,
                        }));
                      },
                    },
                    {
                      label: "Try again",
                      onClick: () =>
                        handleRefreshRefundFee(airlinePriceModal.order),
                    },
                    {
                      label: "Assign",
                      onClick: () => {
                        setOpenAssignRefund(airlinePriceModal.order);
                        setAirlinePriceModal((prev) => ({
                          ...prev,
                          open: false,
                        }));
                      },
                    },
                  ]
              : []
        }
      />
      <StaffAsyncActionModal
        open={supplierStatusModal.open}
        setOpen={(next) =>
          setSupplierStatusModal((prev) => ({ ...prev, open: Boolean(next) }))
        }
        title={
          ["confirming", "confirmed", "confirm_failed", "confirm_warn"].includes(
            supplierStatusModal.kind,
          )
            ? "Confirm refund now"
            : [
                  "reimbursing",
                  "reimbursed",
                  "reimburse_failed",
                  "reimburse_warn",
                ].includes(supplierStatusModal.kind)
              ? "Re-imburse / Refund"
              : "Check supplier status"
        }
        phase={supplierStatusModal.phase}
        loadingTitle={
          supplierStatusModal.kind === "confirming"
            ? "Confirming this refund"
            : supplierStatusModal.kind === "reimbursing"
              ? "Paying the agent wallet"
              : "Asking the airline for an update"
        }
        loadingText="This can take a few seconds. Stay on this screen. Do not click again."
        resultTitle={supplierStatusModal.title}
        resultText={supplierStatusModal.text}
        resultSteps={supplierStatusModal.steps}
        actions={getSupplierStatusActions()}
      />
      <StaffAsyncActionModal
        open={refundRetryModal.open}
        setOpen={(next) =>
          setRefundRetryModal((prev) => ({ ...prev, open: Boolean(next) }))
        }
        title={getRefundRetryAutoActionLabel()}
        phase={refundRetryModal.phase}
        loadingTitle={getRefundRetryAutoLoadingTitle()}
        loadingText="This can take a few seconds. Stay on this screen. Do not click again."
        resultTitle={refundRetryModal.title}
        resultText={refundRetryModal.text}
        actions={getRefundRetryActions()}
      />
      <StaffAsyncActionModal
        open={voidActionModal.open}
        setOpen={(next) =>
          setVoidActionModal((prev) => ({ ...prev, open: Boolean(next) }))
        }
        title={
          [
            "airline_decline_warn",
            "airline_declining",
            "airline_declined",
            "airline_decline_failed",
          ].includes(voidActionModal.kind)
            ? getVoidAirlineDeclinedActionLabel()
            : ["manual_warn", "manualing", "manualed", "manual_failed"].includes(
                voidActionModal.kind,
              )
              ? getVoidManualActionLabel(voidActionModal.order)
              : getVoidSubmitActionLabel()
        }
        phase={voidActionModal.phase}
        loadingTitle={
          voidActionModal.kind === "airline_declining"
            ? "Recording airline decline"
            : voidActionModal.kind === "manualing"
              ? getVoidManualLoadingTitle(voidActionModal.order)
              : getVoidRetryAutoLoadingTitle()
        }
        loadingText="This can take a few seconds. Stay on this screen. Do not click again."
        resultTitle={voidActionModal.title}
        resultText={voidActionModal.text}
        actions={getVoidActionActions()}
      />
      <StaffAsyncActionModal
        open={changeActionModal.open}
        setOpen={(next) =>
          setChangeActionModal((prev) => ({ ...prev, open: Boolean(next) }))
        }
        title={
          ["open_opened_warn", "open_opening", "open_opened", "open_opened_failed"].includes(
            changeActionModal.kind,
          )
            ? "Record opened"
            : ["open_proceed_warn", "open_proceeding", "open_proceeded", "open_proceed_failed"].includes(
            changeActionModal.kind,
          )
            ? "Proceed with the airline"
            : ["manual_warn"].includes(changeActionModal.kind)
            ? "Record a manual change"
            : [
                "retry_auto_warn",
                "retry_autoing",
                "retry_autoed",
                "retry_auto_failed",
              ].includes(changeActionModal.kind)
              ? getChangeRetryAutoActionLabel()
            : ["reissue_warn", "reissuing", "reissued", "reissue_failed"].includes(
                changeActionModal.kind,
              )
              ? "Confirm re-issue"
              : "Confirm sent to airline"
        }
        phase={changeActionModal.phase}
        loadingTitle={
          changeActionModal.kind === "open_opening"
            ? "Recording this as opened"
            : changeActionModal.kind === "open_proceeding"
            ? "Moving this to the airline"
            : changeActionModal.kind === "retry_autoing"
            ? getChangeRetryAutoLoadingTitle()
            : changeActionModal.kind === "reissuing"
            ? "Writing the new ticket into Intraverse"
            : "Telling Intraverse this has been sent"
        }
        loadingText="This can take a few seconds. Stay on this screen. Do not click again. A timeout is not an airline decline."
        resultTitle={changeActionModal.title}
        resultText={changeActionModal.text}
        actions={getChangeActionActions()}
      />
      <StaffApiErrorModal
        open={Boolean(staffApiError)}
        setOpen={(next) => {
          if (!next) setStaffApiError(null);
        }}
        title={staffApiError?.title}
        text={staffApiError?.text}
      />
      <RefundReviewModal
        open={Boolean(openReviewRefund)}
        setOpen={setOpenReviewRefund}
        data={openReviewRefund}
        onDone={() => {
          setOpenReviewRefund(false);
          reload && reload();
        }}
        onQuote={() => {
          const row = openReviewRefund;
          setOpenReviewRefund(false);
          if (row) setOpenRefundQuote(row);
        }}
        onSubmit={() => {
          const row = openReviewRefund;
          setOpenReviewRefund(false);
          if (row) setOpenSubmitRefund(row?._id || row);
        }}
        onReimburse={() => {
          const row = openReviewRefund;
          setOpenReviewRefund(false);
          if (row) setOpenManualRefund(row);
        }}
      />
      <VoidReviewModal
        open={Boolean(openReviewVoid)}
        setOpen={setOpenReviewVoid}
        data={openReviewVoid}
        onDone={() => {
          setOpenReviewVoid(false);
          reload && reload();
        }}
        onSubmit={() => {
          const row = openReviewVoid;
          setOpenReviewVoid(false);
          if (row) promptSubmitVoid(row);
        }}
        onManualVoid={() => {
          const row = openReviewVoid;
          setOpenReviewVoid(false);
          if (row) promptRecordManualVoid(row);
        }}
      />
      <ChangeReviewModal
        open={Boolean(openReviewChange)}
        setOpen={(next) => {
          if (!next) setOpenReviewChange(false);
        }}
        data={openReviewChange}
        onDone={() => {
          setOpenReviewChange(false);
          reload && reload();
        }}
        onViewSelectedOffer={() => {
          const row = openReviewChange;
          if (row) setOpenChangeSelectedOffer(row);
        }}
        onQuote={() => {
          const row = openReviewChange;
          setOpenReviewChange(false);
          if (
            row?.changeRequest === "PassengerInfo" ||
            row?.newDirections
          ) {
            setOpenManualChangeQuote(row);
          } else {
            setOpenChangeQuote(row);
          }
        }}
        onSubmit={() => {
          const row = openReviewChange;
          setOpenReviewChange(false);
          if (row) promptSubmitChange(row);
        }}
        onManualChange={() => {
          const row = openReviewChange;
          setOpenReviewChange(false);
          if (row) promptRecordManualChange(row);
        }}
      />
      <ChangeSelectedOfferModal
        open={Boolean(openChangeSelectedOffer)}
        setOpen={(next) => {
          if (!next) setOpenChangeSelectedOffer(false);
        }}
        data={openChangeSelectedOffer}
      />
      <OpenTicketReviewModal
        open={Boolean(openReviewOpenTicket)}
        setOpen={setOpenReviewOpenTicket}
        data={openReviewOpenTicket}
        onDone={() => {
          setOpenReviewOpenTicket(false);
          reload && reload();
        }}
      />
      <OpenTicketReviewModal
        open={Boolean(openProcessOpenTicket)}
        setOpen={setOpenProcessOpenTicket}
        data={openProcessOpenTicket}
        step="processing"
        onProceed={(order) => {
          setOpenProcessOpenTicket(false);
          promptProceedOpenTicket(order);
        }}
        onDone={() => {
          setOpenProcessOpenTicket(false);
          reload && reload();
        }}
      />
      <OpenTicketReviewModal
        open={Boolean(openRecordOpenTicket)}
        setOpen={setOpenRecordOpenTicket}
        data={openRecordOpenTicket}
        step="supplier"
        onOpened={(order) => {
          setOpenRecordOpenTicket(false);
          promptRecordOpenedOpenTicket(order);
        }}
        onDone={() => {
          setOpenRecordOpenTicket(false);
          reload && reload();
        }}
      />
    </div>
  );
}

export function ActionHandles({
  reload,
  openPayment,
  setOpenPayment,
  openCancelTicket,
  setOpenCancelTicket,
  openCancelOrder,
  setOpenCancelOrder,
  openApproveFreeze,
  setOpenApproveFreeze,
  openManageFreeze,
  setOpenManageFreeze,
  openIssueTicket,
  setOpenIssueTicket,
  openVoidTicket,
  setOpenVoidTicket,
  openManualIssue,
  setOpenManualIssue,
  openDeny,
  setOpenDeny,
  openDenyVoid,
  setOpenDenyVoid,
  openApproveRefund,
  setOpenApproveRefund,
  openDenyRefund,
  setOpenDenyRefund,
  openRequestInfo,
  setOpenRequestInfo,
  openEditRefund,
  setOpenEditRefund,
  openEditChange,
  setOpenEditChange,
  openDenyChange,
  setOpenDenyChange,
  openTicketMoreInfo,
  setOpenTicketMoreInfo,
  openViewDetail,
  setOpenViewDetail,
  openApproveTicket,
  setOpenApproveTicket,
  openApproveChange,
  setOpenApproveChange,
  openAssignTicket,
  setOpenAssignTicket,
  openAssignVoid,
  setOpenAssignVoid,
  openAssignChangeTask,
  setOpenAssignChangeTask,
  openAssignRefund,
  setOpenAssignRefund,
  openUpdateChangeRequest,
  setOpenUpdateChangeRequest,
  openVoidRemark,
  setOpenVoidRemark,
  openRefundRemark,
  setOpenRefundRemark,
  openChangeQuote,
  setOpenChangeQuote,
  openChangeFareRules,
  setOpenChangeFareRules,
  openChangeSelectedOffer,
  setOpenChangeSelectedOffer,
  openChangeMessages,
  setOpenChangeMessages,
  openVoidMessages,
  setOpenVoidMessages,
  openVoidSupplierResponse,
  setOpenVoidSupplierResponse,
  openRefundMessages,
  setOpenRefundMessages,
  openOrderMessages,
  setOpenOrderMessages,
  openChangeBankTransferProof,
  setOpenChangeBankTransferProof,
  setOpenEditTicket,
  openEditTicket,
  openManualChangeQuote,
  setOpenManualChangeQuote,
  openRefundQuote,
  setOpenRefundQuote,
  openApproveRefundQuote,
  setOpenApproveRefundQuote,
  openSubmitRefund,
  setOpenSubmitRefund,
  openSubmitChange,
  setOpenSubmitChange,
  openAdminChangePay,
  setOpenAdminChangePay,
  openManualUpdate,
  setOpenManualUpdate,
  openChangeSupplierOutcome,
  setOpenChangeSupplierOutcome,
  openManualRefund,
  setOpenManualRefund,
  openManualVoid,
  setOpenManualVoid,
  openIssue,
  setOpenIssue,
  openRebook,
  setOpenRebook,
  openPDFExport,
  setOpenPDFExport,
  openEmailExport,
  setOpenEmailExport,
  openAddSeat,
  setOpenAddSeat,
  openEditPayable,
  setOpenEditPayable,
  showStaffApiError = () => {},
}) {
  const {
    userData: { user },
  } = useSelector((state) => state.user);
  const [loadings, setLoadings] = useState({});
  const [openPin, setOpenPin] = useState(false);
  const componentRef = useRef();
  const { sendPDF, handlePDFExport } = useFlightBooking();

  async function handleEmailExport(datas) {
    setOpenPDFExport("loading");

    await handlePDFExport({
      id: openEmailExport,
      callback: (res) => {
        setOpenPDFExport(res?.data);
      },
      returnBolb: (pdf, booking) => sendPDF({ pdf, datas, booking }),
    });
    setOpenEmailExport(false);
  }

  async function handleManualIssue({ _id, travelerTicket }, pin) {
    if (!pin && user?.advancedSecurityEnabled)
      return setOpenPin({
        callback: (pin) => handleManualIssue({ _id, travelerTicket }, pin),
      });

    const reqBody = {
      ticketQueueId: _id,
      travelerTicket,
      pin,
    };
    // return console.log(reqBody)
    setOpenManualIssue({ ...openManualIssue, loading: true });
    const res = await issueTicketManually(reqBody);
    setOpenManualIssue({ ...openManualIssue, loading: false });
    if (res.return) {
      enqueueSnackbar("Ticket has been issued.", { variant: "success" });
      reload && reload();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  async function handleDeny({ _id, deniedReason, ...rest }) {
    console.log("request: ", rest);
    const reqBody = {
      ticketQueueId: _id,
      deniedReason,
    };
    setOpenDeny({ ...openDeny, loading: true });
    const res = await denyTicket(reqBody);
    setOpenDeny({ ...openDeny, loading: false });

    if (res.return) {
      enqueueSnackbar("Ticket request has been denied.", {
        variant: "success",
      });
      reload && reload();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  async function handleDenyVoid({ _id, rejectReason, ...rest }) {
    console.log("request: ", rest);
    const reqBody = {
      // ticketQueueId: _id,
      rejectReason,
    };
    setOpenDenyVoid({ ...openDenyVoid, loading: true });
    const res = await denyVoidRequest(_id, reqBody);
    setOpenDenyVoid({ ...openDenyVoid, loading: false });

    if (res.return) {
      enqueueSnackbar(
        isVoidCloseRequestStage(openDenyVoid)
          ? "This void request has been closed."
          : "Void request has been denied.",
        { variant: "success" },
      );
      reload && reload();
    } else showStaffApiError(res);
  }

  async function handleRequestInfo({ _id, requestedInfo }) {
    const reqBody = {
      ticketQueueId: _id,
      requestedInfo,
    };
    setOpenRequestInfo({ ...openRequestInfo, loading: true });
    const res = await requestTicketMoreInfo(reqBody);
    setOpenRequestInfo({ ...openRequestInfo, loading: false });

    if (res.return) {
      enqueueSnackbar("More info has has been requested.", {
        variant: "success",
      });
      reload && reload();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  async function handleVoid(id) {
    setOpenVoidTicket({ ...openVoidTicket, loading: true });
    const res = await voidTicketRequest(id);
    setOpenVoidTicket({ ...openVoidTicket, loading: false });
    if (res.return) {
      enqueueSnackbar("Ticket has been Void.", { variant: "success" });
      reload && reload();
    } else showStaffApiError(res);
  }

  async function handleSubmitRefund(id) {
    setOpenSubmitRefund({ ...openSubmitRefund, loading: true });
    const res = await submitRefund(id);
    setOpenSubmitRefund({ ...openSubmitRefund, loading: false });
    if (res?.return) {
      enqueueSnackbar(res?.msg || "Refund submitted successfully", {
        variant: "success",
      });
      reload && reload();
    } else showStaffApiError(res, "We could not mark this as sent");
  }
  async function handleSubmitChange(id) {
    setOpenSubmitChange({ ...openSubmitChange, loading: true });
    const res = await submitChange(id);
    setOpenSubmitChange({ ...openSubmitChange, loading: false });
    if (res?.return) {
      enqueueSnackbar(res?.msg || "Change submitted successfully", {
        variant: "success",
      });
      reload && reload();
    } else showStaffApiError(res, "We could not mark this as sent");
  }

  async function handleAdminChangePay(order) {
    const changeOrderId = order?._id || order?.changeOrderId;
    setOpenAdminChangePay({ ...openAdminChangePay, loading: true });
    const res = await adminPayForChangeRequest({ changeOrderId });
    setOpenAdminChangePay({ ...openAdminChangePay, loading: false });
    if (res?.return) {
      enqueueSnackbar(
        res?.msg ||
          "Payment taken from the agent wallet. Submit to the airline next.",
        { variant: "success" },
      );
      reload && reload();
      setOpenAdminChangePay(false);
    } else showStaffApiError(res, "We could not take payment");
  }

  async function handleServiceCharge({ _id, refundAmount }) {
    const reqBody = {
      refundRequestId: _id,
      refundAmount: Number(refundAmount),
    };
    setOpenEditRefund({ ...openEditRefund, loading: true });
    const res = await setRefundFee(reqBody);
    setOpenEditRefund({ ...openEditRefund, loading: false });

    if (res.return) {
      enqueueSnackbar("Service charge has been set.", { variant: "success" });
      reload && reload();
    } else showStaffApiError(res);
  }

  async function handleChangeFee({ _id, changePrice, ticketDifference }) {
    const reqBody = {
      changeOrderId: _id,
      changePrice: Number(changePrice),
      ticketDifference: Number(ticketDifference),
    };
    setOpenEditChange({ ...openEditChange, loading: true });
    const res = await setChangeFee(reqBody);
    setOpenEditChange({ ...openEditChange, loading: false });

    if (res.return) {
      enqueueSnackbar("Service charge has been set.", { variant: "success" });
      reload && reload();
    } else showStaffApiError(res);
  }

  async function handleApprove(id) {
    const reqBody = {
      ticketQueueId: id,
    };
    setLoadings({ ...(loadings || {}), approveTicket: true });
    const res = await approveTicket(reqBody);
    setLoadings({ ...(loadings || {}), approveTicket: false });
    if (res.return) {
      enqueueSnackbar("Ticket request has been approved.", {
        variant: "success",
      });
      reload && reload();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  async function handleApproveChange(idOrOrder) {
    const id =
      typeof idOrOrder === "object" && idOrOrder
        ? idOrOrder._id || idOrOrder.id
        : idOrOrder;
    if (!id) {
      showStaffApiError({ msg: "Missing change request id" });
      return;
    }
    setLoadings({ ...(loadings || {}), approveChangeTicket: true });
    const res = await approveChangeTicketRequest(id);
    setLoadings({ ...(loadings || {}), approveChangeTicket: false });
    if (res.return) {
      enqueueSnackbar("Request accepted. You can create a quote now.", {
        variant: "success",
      });
      setOpenApproveChange(false);
      reload && reload();
    } else showStaffApiError(res);
  }

  async function handleApproveRefund(id) {
    setLoadings({ ...(loadings || {}), approveRefundTicket: true });
    const res = await approveRefundTicket(id);
    setLoadings({ ...(loadings || {}), approveRefundTicket: false });
    if (res.return) {
      enqueueSnackbar("Request accepted. You can create a quote now.", {
        variant: "success",
      });
      reload && reload();
    } else showStaffApiError(res);
  }

  async function handleIssue(id, pin) {
    if (!pin && user?.advancedSecurityEnabled)
      return setOpenPin({ callback: (pin) => handleIssue(id, pin) });

    const reqBody = {
      ticketQueueId: id,
      pin,
    };
    setLoadings({ ...(loadings || {}), issueTicket: true });
    const res = await issueTicket(reqBody);
    setLoadings({ ...(loadings || {}), issueTicket: false });
    if (res.return) {
      enqueueSnackbar("Ticket has been issued.", { variant: "success" });
      reload && reload();
    } else enqueueSnackbar(res.msg, { variant: "error" });
  }

  return (
    <div>
      <Modal3 title={"PIN"} open={openPin} setOpen={() => setOpenPin(false)}>
        <PinForm
          callback={(pin) => {
            setOpenPin(false);
            openPin?.callback && openPin?.callback(pin);
          }}
          close={() => setOpenPin(false)}
        />
      </Modal3>
      <FlightAdminPayModal open={openPayment} setOpen={setOpenPayment} />
      {/* <Modal1 open={openPayment} setOpen={setOpenPayment}>
        <PaymentMethod
          callback={() => {
            reload && reload();
            setOpenPayment(false);
          }}
          flightBookingId={openPayment}
          hide={["booklater"]}
          expand
        />
      </Modal1> */}

      <CancelOrder
        open={openCancelOrder}
        setOpen={setOpenCancelOrder}
        callback={() => {
          reload && reload();
          setOpenCancelOrder(false);
        }}
      />
      <ApproveFreezeOrder
        open={openApproveFreeze}
        setOpen={setOpenApproveFreeze}
        callback={() => {
          reload && reload();
          setOpenApproveFreeze(false);
        }}
      />
      <ManageFreezeOrderModal
        open={openManageFreeze}
        setOpen={setOpenManageFreeze}
        callback={() => {
          reload && reload();
          setOpenManageFreeze(false);
        }}
      />
      <EditPayableForFlightModal
        open={openEditPayable}
        setOpen={setOpenEditPayable}
      />

      <Modal1 open={openManualIssue} setOpen={setOpenManualIssue}>
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          <h5>Ticket Number?</h5>
          <ManualTicketForm
            travelers={openManualIssue?.flightBooking?.at(0)?.travelers}
            flightData={openManualIssue}
            onChange={(obj) =>
              setOpenManualIssue({ ...openManualIssue, travelerTicket: obj })
            }
          />
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setOpenManualIssue(false)}
            >
              Cancel
            </Button1>
            <div>
              <Button1
                onClick={() => handleManualIssue(openManualIssue)}
                loading={openManualIssue?.loading}
              >
                Issue Ticket
              </Button1>
            </div>
          </div>
        </div>
      </Modal1>

      <Modal1 open={openCancelTicket} setOpen={setOpenCancelTicket}>
        <CancelTicket
          data={openCancelTicket}
          callback={() => {
            reload && reload();
            setOpenCancelTicket(false);
          }}
          close={() => setOpenCancelTicket(false)}
        />
      </Modal1>

      <Modal1 open={openIssueTicket} setOpen={setOpenIssueTicket}>
        <IssueTicket
          data={openIssueTicket}
          callback={() => {
            reload && reload();
            setOpenIssueTicket(false);
          }}
          close={() => setOpenIssueTicket(false)}
        />
      </Modal1>

      <Modal3
        open={openRequestInfo}
        setOpen={setOpenRequestInfo}
        title={"Request More Info"}
      >
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          {/* <h5>What's missing?</h5> */}
          <TextInput
            label="Remarks"
            multiline
            rows={5}
            placeholder={"e.g. Phone number is required"}
            value={openRequestInfo?.requestedInfo || ""}
            onChange={(ev) =>
              setOpenRequestInfo({
                ...openRequestInfo,
                requestedInfo: ev.target.value,
              })
            }
          />
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setOpenRequestInfo(false)}
            >
              Cancel
            </Button1>
            <div>
              <Button1
                onClick={() => handleRequestInfo(openRequestInfo)}
                loading={openRequestInfo?.loading}
              >
                Request more info
              </Button1>
            </div>
          </div>
        </div>
      </Modal3>

      <Modal3
        open={openDeny}
        setOpen={setOpenDeny}
        title={"Decline Ticket Request"}
      >
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          {/* <h5>What's your reson?</h5> */}
          <TextInput
            label="Remark"
            multiline
            rows={5}
            placeholder={"e.g. Ticket not available"}
            value={openDeny?.deniedReason || ""}
            onChange={(ev) =>
              setOpenDeny({ ...openDeny, deniedReason: ev.target.value })
            }
          />
          <div className="flex justify-end items-center gap-4">
            <div>
              <Button1
                variant="outlined"
                className="btn-outlined flex-1"
                onClick={() => setOpenDeny(false)}
              >
                Cancel
              </Button1>
            </div>
            <Button1
              onClick={() => handleDeny(openDeny)}
              loading={openDeny?.loading}
            >
              Decline Request
            </Button1>
          </div>
        </div>
      </Modal3>

      <Modal1 open={openDenyVoid} setOpen={setOpenDenyVoid}>
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          <h5>
            {isVoidCloseRequestStage(openDenyVoid)
              ? "Why are you closing this request?"
              : "Why are you declining this void?"}
          </h5>
          <TextInput
            label=""
            multiline
            rows={5}
            placeholder={"e.g. Void window closed, ticket already used"}
            value={openDenyVoid?.rejectReason || ""}
            onChange={(ev) =>
              setOpenDenyVoid({
                ...openDenyVoid,
                rejectReason: ev.target.value,
              })
            }
          />
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setOpenDenyVoid(false)}
            >
              Cancel
            </Button1>
            <div>
              <Button1
                onClick={() => handleDenyVoid(openDenyVoid)}
                loading={openDenyVoid?.loading}
              >
                {getVoidDeclineActionLabel(openDenyVoid)}
              </Button1>
            </div>
          </div>
        </div>
      </Modal1>

      <RefundDeclineModal
        open={Boolean(openDenyRefund)}
        setOpen={setOpenDenyRefund}
        data={openDenyRefund}
        onDone={() => {
          setOpenDenyRefund(false);
          reload && reload();
        }}
      />

      <ChangeDeclineModal
        open={Boolean(openDenyChange)}
        setOpen={setOpenDenyChange}
        data={openDenyChange}
        onDone={() => {
          setOpenDenyChange(false);
          reload && reload();
        }}
      />

      <Modal1 open={openVoidTicket} setOpen={setOpenVoidTicket}>
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          <h5>Are you sure you want to void this ticket?</h5>
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setOpenVoidTicket(false)}
            >
              No, Close
            </Button1>
            <div>
              <Button1
                onClick={() => handleVoid(openVoidTicket)}
                loading={openVoidTicket?.loading}
              >
                Yes, Void Ticket
              </Button1>
            </div>
          </div>
        </div>
      </Modal1>

      <Modal1 open={openEditRefund} setOpen={setOpenEditRefund}>
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          <h5>Refund Amount</h5>
          <TextInput
            label=""
            type="number"
            placeholder={"Amount in NGN"}
            value={openEditRefund?.refundAmount || ""}
            onChange={(ev) =>
              setOpenEditRefund({
                ...openEditRefund,
                refundAmount: ev.target.value,
              })
            }
          />
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setOpenEditRefund(false)}
            >
              Close
            </Button1>
            <div>
              <Button1
                onClick={() => handleServiceCharge(openEditRefund)}
                loading={openEditRefund?.loading}
              >
                Continue
              </Button1>
            </div>
          </div>
        </div>
      </Modal1>

      <Modal3
        open={openSubmitRefund}
        setOpen={setOpenSubmitRefund}
        title={getRefundSubmitActionLabel()}
      >
        <div className="card p-4 flex flex-col gap-4 min-w-[300px]">
          <div className="py-4">
            Only continue if you already opened the airline or supplier site and
            submitted the refund there. This button only tells Intraverse you
            submitted it. It does not pay the agent. A timeout is not an airline
            decline.
          </div>
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setOpenSubmitRefund(false)}
            >
              Close
            </Button1>
            <div>
              <Button1
                onClick={() => handleSubmitRefund(openSubmitRefund)}
                loading={openSubmitRefund?.loading}
              >
                Yes, I submitted it on the airline site
              </Button1>
            </div>
          </div>
        </div>
      </Modal3>

      <Modal3
        open={openSubmitChange}
        setOpen={setOpenSubmitChange}
        title={"Confirm sent to airline"}
      >
        <div className="card p-4 flex flex-col gap-4 min-w-[300px]">
          <div className="py-4">
            Confirm you have submitted this change to the airline or supplier.
            A timeout is not an airline decline.
          </div>
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setOpenSubmitChange(false)}
            >
              Close
            </Button1>
            <div>
              <Button1
                onClick={() => handleSubmitChange(openSubmitChange)}
                loading={openSubmitChange?.loading}
              >
                Yes, it has been sent
              </Button1>
            </div>
          </div>
        </div>
      </Modal3>

      <Modal3
        open={openAdminChangePay}
        setOpen={setOpenAdminChangePay}
        title={"Pay from agent wallet"}
      >
        <div className="card p-4 flex flex-col gap-4 min-w-[300px]">
          <div className="py-4">
            This takes the quoted change charge from the agent wallet. Do not
            submit to the airline until this succeeds.
          </div>
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setOpenAdminChangePay(false)}
            >
              Back
            </Button1>
            <div>
              <Button1
                onClick={() => handleAdminChangePay(openAdminChangePay)}
                loading={openAdminChangePay?.loading}
              >
                Take payment
              </Button1>
            </div>
          </div>
        </div>
      </Modal3>

      <Modal1 open={openEditChange} setOpen={setOpenEditChange}>
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          <h5>Refund Amount</h5>
          <TextInput
            label="Change Fee "
            type="number"
            placeholder={"Amount in NGN"}
            value={openEditChange?.changePrice || ""}
            onChange={(ev) =>
              setOpenEditChange({
                ...openEditChange,
                changePrice: ev.target.value,
              })
            }
          />
          <TextInput
            label="Ticket difference"
            type="number"
            placeholder={"Amount in NGN"}
            value={openEditChange?.ticketDifference || ""}
            onChange={(ev) =>
              setOpenEditChange({
                ...openEditChange,
                ticketDifference: ev.target.value,
              })
            }
          />
          <div className="flex justify-end items-center gap-4">
            <Button1
              variant="outlined"
              className="btn-outlined flex-1"
              onClick={() => setOpenEditChange(false)}
            >
              Close
            </Button1>
            <div>
              <Button1
                onClick={() => handleChangeFee(openEditChange)}
                loading={openEditChange?.loading}
              >
                Continue
              </Button1>
            </div>
          </div>
        </div>
      </Modal1>

      <Modal3 open={openTicketMoreInfo} setOpen={setOpenTicketMoreInfo}>
        Test
      </Modal3>

      <Modal3
        open={openViewDetail}
        setOpen={setOpenViewDetail}
        title={"View Booking Details"}
      >
        <TicketManagementFlightOrderDetail
          fetchId={openViewDetail?.id}
          page={openViewDetail?.page}
        />
      </Modal3>

      <Modal3
        open={openApproveTicket}
        setOpen={setOpenApproveTicket}
        title={"Confirm Ticket Issuance"}
      >
        <div className="max-w-[500px]">
          <div className="p-4">
            <p>
              Are you sure you want to approve the issuance of this ticket? This
              action cannot be undone.
            </p>
          </div>
          <div className="flex gap-4 p-4">
            <Button1 variant="text" onClick={() => setOpenApproveTicket(false)}>
              Cancel
            </Button1>
            <Button1
              loading={loadings?.approveTicket}
              onClick={() => handleApprove(openApproveTicket)}
            >
              Confirm
            </Button1>
          </div>
        </div>
      </Modal3>

      <Modal3
        open={openApproveChange}
        setOpen={setOpenApproveChange}
        title={"Confirm Re-Issue Request Approval"}
      >
        <div className="max-w-[500px] p-4">
          <div className="p-4">
            <p>
              Are you sure you want to approve the re-issue of this ticket? This
              action will override the current ticket details.
            </p>
          </div>
          <div className="flex gap-4">
            <Button1 variant="text" onClick={() => setOpenApproveChange(false)}>
              Cancel
            </Button1>
            <Button1
              loading={loadings?.approveChangeTicket}
              onClick={() => handleApproveChange(openApproveChange)}
            >
              Confirm
            </Button1>
          </div>
        </div>
      </Modal3>

      <Modal3
        open={openApproveRefund}
        setOpen={setOpenApproveRefund}
        title={"Accept Refund Request Task"}
      >
        <div className="max-w-[500px] p-4">
          <div className="p-4">
            <p>
              Accept this request first. After it is accepted, you can get an
              airline price or type a quote.
            </p>
          </div>
          <div className="flex gap-4">
            <Button1 variant="text" onClick={() => setOpenApproveRefund(false)}>
              Cancel
            </Button1>
            <Button1
              loading={loadings?.approveRefundTicket}
              onClick={() => handleApproveRefund(openApproveRefund)}
            >
              Accept Request
            </Button1>
          </div>
        </div>
      </Modal3>

      <Modal3
        open={openAssignChangeTask}
        setOpen={setOpenAssignChangeTask}
        title={"Assign Task"}
      >
        <div className="p-4 max-w-[700px]">
          <AssignChange callback={reload} data={openAssignChangeTask} />
        </div>
      </Modal3>

      <Modal3
        open={openUpdateChangeRequest}
        setOpen={setOpenUpdateChangeRequest}
        title={"Add an update"}
      >
        <div className="card p-4 flex flex-col  gap-4 md:min-w-[500px]">
          <AddRemarkMessage data={openUpdateChangeRequest} />
        </div>
      </Modal3>
      <Modal3
        open={openVoidRemark}
        setOpen={setOpenVoidRemark}
        title={"Add remark"}
      >
        <div className="card p-4 flex flex-col gap-4 md:min-w-[500px]">
          <AddVoidRemark
            data={openVoidRemark}
            close={() => setOpenVoidRemark(false)}
            callback={reload}
          />
        </div>
      </Modal3>
      <Modal3
        open={openRefundRemark}
        setOpen={setOpenRefundRemark}
        title={"Add remark"}
      >
        <div className="card p-4 flex flex-col gap-4 md:min-w-[500px]">
          <AddRefundRemark
            data={openRefundRemark}
            close={() => setOpenRefundRemark(false)}
            callback={reload}
          />
        </div>
      </Modal3>

      <Modal3
        open={openChangeQuote}
        setOpen={setOpenChangeQuote}
        title={"Quote"}
      >
        <div className="p-4 max-w-[700px] md:min-w-[500px]">
          <ChangeQuote data={openChangeQuote} reload={reload} />
        </div>
      </Modal3>

      <ChangeFareRulesModal
        data={openChangeFareRules}
        open={Boolean(openChangeFareRules)}
        setOpen={(next) => {
          if (!next) setOpenChangeFareRules(false);
        }}
      />
      <ChangeMessagesModal
        data={openChangeMessages}
        open={Boolean(openChangeMessages)}
        setOpen={(next) => {
          if (!next) setOpenChangeMessages(false);
        }}
      />
      <VoidMessagesModal
        data={openVoidMessages}
        open={Boolean(openVoidMessages)}
        setOpen={(next) => {
          if (!next) setOpenVoidMessages(false);
        }}
      />
      <SupplierResponseModal
        open={Boolean(openVoidSupplierResponse)}
        setOpen={(next) => {
          if (!next) setOpenVoidSupplierResponse(false);
        }}
        data={openVoidSupplierResponse?.supplierResponse}
        orderId={openVoidSupplierResponse?.orderId}
      />
      <RefundMessagesModal
        data={openRefundMessages}
        open={Boolean(openRefundMessages)}
        setOpen={(next) => {
          if (!next) setOpenRefundMessages(false);
        }}
      />
      <ChangeMessagesModal
        data={openOrderMessages}
        open={Boolean(openOrderMessages)}
        setOpen={(next) => {
          if (!next) setOpenOrderMessages(false);
        }}
      />
      <ChangeBankTransferProofModal
        data={openChangeBankTransferProof}
        open={Boolean(openChangeBankTransferProof)}
        setOpen={(next) => {
          if (!next) setOpenChangeBankTransferProof(false);
        }}
        onUpdated={() => {
          setOpenChangeBankTransferProof(false);
          reload?.();
        }}
      />
      <Modal3
        open={openEditTicket}
        setOpen={setOpenEditTicket}
        title={"Edit Ticket"}
      >
        <div className="p-4 max-w-[700px] md:min-w-[500px]">
          <EditTicket data={openEditTicket} reload={reload} />
        </div>
        {/* <div className="p-4 max-w-[800px] md:min-w-[500px]">
          <ManualChangeQuote
            data={openEditTicket}
            reload={reload}
            close={() => setOpenEditTicket(false)}
          />
        </div> */}
      </Modal3>
      <Modal3
        open={openManualChangeQuote}
        setOpen={setOpenManualChangeQuote}
        title={"Quote"}
      >
        <div className="p-4 max-w-[800px] md:min-w-[500px]">
          <ManualChangeQuote
            data={openManualChangeQuote}
            reload={reload}
            close={() => setOpenManualChangeQuote(false)}
            onViewSelectedOffer={() =>
              setOpenChangeSelectedOffer(openManualChangeQuote)
            }
          />
        </div>
      </Modal3>

      <Modal3
        open={openRefundQuote}
        setOpen={setOpenRefundQuote}
        title={"Quote"}
      >
        <div className="p-4 max-w-[700px] md:min-w-[500px]">
          <RefundQuote data={openRefundQuote} reload={reload} />
        </div>
      </Modal3>

      <ApproveRefundQuoteModal
        open={Boolean(openApproveRefundQuote)}
        setOpen={setOpenApproveRefundQuote}
        data={openApproveRefundQuote}
        onDone={() => {
          setOpenApproveRefundQuote(false);
          reload && reload();
        }}
      />

      <Modal3
        open={openAssignRefund}
        setOpen={setOpenAssignRefund}
        title={"Assign Task"}
      >
        <div className="p-4 max-w-[700px]">
          <AssignRefund callback={reload} data={openAssignRefund} />
        </div>
      </Modal3>

      <Modal3
        open={openAssignTicket}
        setOpen={setOpenAssignTicket}
        title={"Assign Task"}
      >
        <div className="p-4 max-w-[700px]">
          <AssignTicket
            callback={reload}
            data={openAssignTicket}
            handleIssue={(pin) => handleIssue(openAssignTicket?._id, pin)}
          />
        </div>
      </Modal3>

      <Modal3
        open={openIssue}
        setOpen={() => setOpenIssue(false)}
        title={"Issue Ticket"}
      >
        <div className="p-4 max-w-[700px]">
          <p>Are you sure you want to issue ticket for this booking?</p>
          <div className="flex gap-4 p-4">
            <Button1 variant="text" onClick={() => setOpenIssue(false)}>
              Cancel
            </Button1>
            <Button1
              loading={loadings?.issueTicket}
              onClick={() => handleIssue(openIssue)}
            >
              Confirm
            </Button1>
          </div>
        </div>
      </Modal3>

      <Modal3
        open={openAssignVoid}
        setOpen={setOpenAssignVoid}
        title={"Assign Task"}
      >
        <div className="p-4 max-w-[700px]">
          <AssignVoid
            callback={reload}
            data={openAssignVoid}
            handleVoid={() => handleVoid(openAssignVoid?._id)}
          />
        </div>
      </Modal3>

      <Modal3
        open={openManualUpdate}
        setOpen={setOpenManualUpdate}
        title="Record successful exchange"
      >
        <div className="p-4 max-w-[700px]">
          <ManualUpdate
            callback={reload}
            data={openManualUpdate}
            close={() => setOpenManualUpdate(false)}
          />
        </div>
      </Modal3>

      <Modal3
        open={Boolean(openChangeSupplierOutcome)}
        setOpen={setOpenChangeSupplierOutcome}
        title="Record airline / supplier result"
      >
        <div className="p-4 max-w-[560px]">
          <ChangeSupplierOutcomeForm
            data={
              typeof openChangeSupplierOutcome === "object"
                ? openChangeSupplierOutcome
                : null
            }
            initialKind={
              openChangeSupplierOutcome?.outcomeKind ||
              CHANGE_SUPPLIER_OUTCOME.decline
            }
            callback={reload}
            close={() => setOpenChangeSupplierOutcome(false)}
          />
        </div>
      </Modal3>

      <Modal3
        open={openManualRefund}
        setOpen={setOpenManualRefund}
        title="Credit agent wallet"
      >
        <div className="p-4 max-w-[700px]">
          <ManualRefund callback={reload} data={openManualRefund} />
        </div>
      </Modal3>

      <Modal3
        open={openManualVoid}
        setOpen={setOpenManualVoid}
        title="Manual Void"
      >
        <div className="p-4 max-w-[700px]">
          <ManualVoid callback={reload} data={openManualVoid} />
        </div>
      </Modal3>

      <Modal1 open={openRebook} setOpen={setOpenRebook}>
        <Rebook data={openRebook} />
      </Modal1>

      <Modal1 open={openPDFExport} setOpen={setOpenPDFExport}>
        {/* <ReactToPrint content={() => componentRef}>
          <PrintContextConsumer>
            {({ handlePrint }) => (
              <button onClick={handlePrint}>Print this out!</button>
              )}
          </PrintContextConsumer> */}
        <div ref={componentRef}>
          {openPDFExport === "loading" ? (
            <div className="flex justify-center items-center h-full p-4">
              <CircularProgress className="!w-10 !h-10" />
            </div>
          ) : (
            <FlightDoc data={openPDFExport} />
          )}
        </div>
        {/* </ReactToPrint> */}
      </Modal1>

      <Modal1 open={openEmailExport} setOpen={setOpenEmailExport}>
        <EmailExport callback={handleEmailExport} />
      </Modal1>

      <Modal1 open={openAddSeat} setOpen={setOpenAddSeat}>
        <div className="card p-4 flex flex-col  gap-4 min-w-[300px]">
          <SeatSelectionHandler offer={openAddSeat?.flightBooking?.at(0)} />
        </div>
      </Modal1>
    </div>
  );
}

export default OrderList;

const Order = ({ order, og, reload }) => {
  const bookingData = Array.isArray(og?.flightBooking)
    ? og.flightBooking.at(0)
    : og?.flightBooking;
  const [open, setOpen] = useState(false);
  const immediateQuotedRefund =
    isRefundQuotedStatus(og?.status) &&
    Boolean(og?.immediateRefund) &&
    !isRefundQuoteExpiredForDisplay(og);
  return (
    <div
      className={`w-full flex justify-between p-4 gap-3 ${
        immediateQuotedRefund
          ? "bg-amber-50 border-l-4 border-l-amber-500"
          : "bg-white"
      }`}
      title={
        immediateQuotedRefund
          ? "Agent chose immediate refund — cancel now regardless of fee"
          : undefined
      }
    >
      <div className="flex flex-col md:flex-row justify-between flex-1">
        {order?.map(({ elements, width }, index) => (
          <div
            className={`w-full ${width || "flex-1"} ${
              !open && index !== 0 ? "hidden md:flex" : "flex"
            } flex-col ${
              open && "border-b pb-3"
            } mb-2 px-2 md:border-b-0 md:pb-0`}
            key={index}
          >
            {elements?.map((element, idx) => (
              <OrderContent element={element} key={idx} />
            ))}
          </div>
        ))}
      </div>
      <div
        className={`${
          bookingData?.status || og?.status ? "flex" : "hidden"
        } flex-col justify-between items-center `}
      >
        <OrderMenu og={og} order={order} reload={reload} />
        <div className="flex md:hidden" onClick={() => setOpen(!open)}>
          {open ? (
            <img
              src="/IconChevronUp.svg"
              alt=""
              className="w-5 object-contain"
            />
          ) : (
            <img
              src="/IconChevronDown.svg"
              alt=""
              className="w-5 object-contain"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export const OrderContent = ({ element, order, callback }) => {
  if (element?.render) return element?.render();

  switch (element.type) {
    case "title":
      return <Title value={element.value} />;
    case "copy":
      return (
        <Copy
          value={element.value}
          render={element?.renderValue}
          link={element?.link}
        />
      );
    case "tag":
      return <Tag element={element} />;
    case "time":
      return <Time value={element?.value} />;
    case "status":
      return <OrderStatus value={element?.value} />;
    case "agencyStatus":
      return <CustomerStatus value={element?.value} />;
    case "abilityStatus":
      return <AbilityStatus value={element?.value} />;
    case "activeStatus":
      return <ActiveStatus value={element?.value} />;
    case "customerModal":
      return <CustomerModalContainer value={element?.value} order={order} />;
    case "toggle":
      return (
        <Toggle value={element?.value} order={order} callback={callback} />
      );
    default:
      return <Text value={element.value} className={element?.className} />;
  }
};

const Text = ({ value, className }) => {
  return (
    <span className={"text-sm mb-2" + " " + className}>
      {typeof value === "string" ? value?.slice(0, 100) : ""}
      {value?.length > 100 ? "..." : ""}
    </span>
  );
};

const Title = ({ value }) => {
  return <span className="text-sm text-[#6D7C94] mb-2">{value}</span>;
};

export const Copy = ({ value, render, link }) => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  const handleCopy = () => {
    if (link) {
      navigate(link);
    } else {
      try {
        navigator.clipboard.writeText(value);
        enqueueSnackbar("Copied to clipboard!", { variant: "success" });
      } catch (error) {
        enqueueSnackbar("Failed to copy to clipboard!", { variant: "error" });
      }
    }
  };

  return (
    <div
      className="flex gap-1 items-center mb-2 cursor-pointer"
      onClick={handleCopy}
    >
      <span className="text-xs text-primary1">{render ? render() : value}</span>
      <img src="/IconCopy.svg" alt="" />
    </div>
  );
};

const Tag = ({ element }) => {
  return (
    <div className={`rounded-md `}>
      <span
        className={`${element?.color} ${element?.background} text-xs font-bold px-2 py-1 rounded-md ${element?.className}`}
      >
        {element?.value}
      </span>
    </div>
  );
};

const Time = ({ value }) => {
  return (
    <div className="flex gap-1 items-center mb-2 cursor-pointer">
      <img src="/IconClock1.svg" alt="" />
      <span className="text-xs">{value}</span>
    </div>
  );
};

export const allStatuses = [
  "Pending",
  "Paid",
  "Not Paid",
  "Failed",
  "Booked",
  "Ticket issued",
  "Issued",
  "Completed",
  "PendingTicketIssue",
  "AwaitingAdmin",
  "Expired",
  "AutoCanceled",
  "Cancelled",
  "CustomerPaid",
  "TicketCanceled",
  "Refunded",
  "TicketCancelationRequested",
];

// Order list
